import {authStore} from '@/composables/store-accessor'

export default defineNuxtRouteMiddleware(to => {
    const hasAccess =
        to.meta.permissions.role.includes(authStore.personRole) &&
        to.meta.permissions.companyType === authStore.companyType

    if (!hasAccess) return navigateTo({name: 'home'})
})
